module.exports = __webpack_public_path__ + "img/tabaat_no.5d4d489b.png";